import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import TestsRequests from "services/tests";
import KeyManagementTableHeading from "./KeyManagementTableHeading";
import KeyManagementTableItem from "./KeyManagementTableItem";

const KeyManagementListTable = ({ searchMode, searchInput }) => {
  const dispatch = useDispatch();
  const { keys, keysCurrentPage, keysTotalPage } = useSelector(
    ({ tests }) => tests
  );

  useEffect(() => {
    if (searchMode) {
      dispatch(TestsRequests.getKeys(1, searchInput));
    } else {
      dispatch(TestsRequests.getKeys(1));
    }
  }, [searchInput, searchMode]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(TestsRequests.getKeys(value, searchInput));
    } else {
      dispatch(TestsRequests.getKeys(value));
    }
  };

  return (
    <div className="Cmt-table-responsive">
      {keys &&
        (keys.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <KeyManagementTableHeading />
            </TableHead>
            <TableBody>
              {keys.map((item) => (
                <KeyManagementTableItem
                  data={item}
                  key={item._id}
                  id={item._id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {keys.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={keysTotalPage}
            color="primary"
            page={keysCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default KeyManagementListTable;
